
    import '/mnt/docs/guide/index.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/index.md?type=demo')
};